import React from 'react';
import PropTypes from 'prop-types';
import FormSupportActions from '../FormSupportActions';
import ProfileControlPanel from '../../containers/ProfileControlPanel';
import { Box, useResponsive } from '@otcmarketsgroup/otcm-ui-lib';

const GlobalActions = () => {
  const { isDesktop } = useResponsive();

  return (
    <Box display='flex' flexDirection='column' gap={2}>
      <ProfileControlPanel />
      {isDesktop && <FormSupportActions />}
    </Box>
  );
};

export default GlobalActions;